export default "__VITE_ASSET__CFGTuV0x__"